module.exports = __webpack_public_path__ + "media/images/uxutees-pattern-bea6d3a92beb57b9ebdab818dbbfc1ca.svg";